import ConfirmSubmissionModal from "./ConfirmSubmissionModal";

export default ConfirmSubmissionModal;
